export type VehicleCategory = "autre" | "carrosserie" | "mecanique";
export type VehicleClass = "vp" | "vu";
export type VehicleUsage = "velos" | "location" | "pret";
export type VehicleFuelType = "diesel" | "essence" | "electrique" | "gpl" | "hybride" | "autre";
/** @deprecated Use tag_ids with OrgTag instead */
export type VehicleTag = "huile" | "rendu_sale" | "reserve" | "assurance" | "a_sortir" | "plein_fait" | "hors_service";
export type VehicleStatus = "disponible" | "en_cours" | "hors_service" | "reserve";
export type VehicleLocationCategory = "A" | "B" | "C" | "D" | "DM" | "E" | "F" | "FP" | "SP" | "1" | "2" | "3" | "4" | "6";
/** Every rental class, in the order the garage reads them. Single source of truth for
 *  the vehicle form and the "catégories proposées en location" booking setting —
 *  mirrors LOCATION_CATEGORIES in the backend's vehicle_controller. */
export const VEHICLE_LOCATION_CATEGORIES: VehicleLocationCategory[] = [
  "A", "B", "C", "D", "DM", "E", "F", "FP", "SP", "1", "2", "3", "4", "6",
];
/** Stands for a location vehicle with no rental class, so "sans catégorie" is an
 *  explicit choice in the booking setting rather than a silent hole. */
export const VEHICLE_LOCATION_CATEGORY_NONE = "AUCUNE";

export type VehicleColoris = "noir" | "blanc" | "gris" | "bleu" | "rouge" | "vert" | "jaune" | "marron" | "orange" | "autre";

export interface Vehicle {
  id: string;
  name: string;
  plate: string;
  km: number;
  category: VehicleCategory;
  vehicle_class?: VehicleClass;
  usage: VehicleUsage;
  fuel_type: VehicleFuelType;
  designation: string;
  tags: VehicleTag[];
  tag_ids?: string[];
  modele: string;
  status: VehicleStatus;
  has_print: boolean;
  coloris?: VehicleColoris;
  marque?: string;
  mec?: number; // Unix timestamp in seconds
  vin?: string;
  notes?: string;
  image_url?: string;
  loc_category?: VehicleLocationCategory;
}

export interface VehicleReservation {
  id: string;
  vehicleId: string;
  clientName: string;
  /** ISO date string YYYY-MM-DD */
  startDate: string;
  /** ISO date string YYYY-MM-DD */
  endDate: string;
  /** Whether pickup icon shows on start */
  hasPickup: boolean;
  /** Whether return icon shows on end */
  hasReturn: boolean;
  /** Decimal start hour for day view (e.g. 9.25 = 9h15). For single-day: start time. For multi-day: pickup time on startDate. */
  startHour?: number;
  /** Duration in hours for single-day reservations (e.g. 2.5 = 2h30). */
  durationHours?: number;
  /** Decimal return hour for multi-day reservations (e.g. 17 = 17h00). Return time on endDate. */
  returnHour?: number;
  /** Linked ordre ID (for rental/loan assignments) */
  ordreId?: string;
  /** Linked dossier/folder ID */
  dossierId?: string;
  notes?: string;
  clientEmail?: string;
  clientPhone?: string;
  kmDepart?: string;
  kmRetour?: string;
  serviceboxDossierId?: string;
  serviceboxPretId?: string;
}
